// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function getStarBgPath(width) {
  var radius = "8.25";
  var width$1 = String(width);
  var height = "1";
  return "M0,0 h" + width$1 + " a" + radius + "," + radius + " 0 0 1 " + radius + "," + radius + " v" + height + " a" + radius + "," + radius + " 0 0 1 -" + radius + "," + radius + " h-" + width$1 + " a" + radius + "," + radius + " 0 0 1 -" + radius + ",-" + radius + " v-" + height + " a" + radius + "," + radius + " 0 0 1 " + radius + ",-" + radius + " z";
}

var starGold = React.createElement("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
      fill: "rgba(255, 205, 79, 0.93)",
      filter: "url(#svg-shadow)",
      transform: "scale(0.667)"
    });

var starTeal = React.createElement("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
      fill: "var(--teal-11)",
      filter: "url(#svg-shadow)",
      transform: "scale(0.667)"
    });

var starWhite = React.createElement("path", {
      d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z",
      fill: "var(--white1)",
      filter: "url(#svg-shadow)",
      transform: "scale(0.667)"
    });

function TbHexStarLevel(Props) {
  var starLevel = Props.starLevel;
  switch (starLevel) {
    case 2 :
        return React.createElement("g", {
                    className: "pointer-events-none",
                    transform: "translate(29, 22)"
                  }, React.createElement("path", {
                        d: getStarBgPath(18),
                        fill: "rgba(96, 125, 139, 0.55)",
                        strokeWidth: "0px",
                        transform: "translate(6, 0)"
                      }), starWhite, React.createElement("g", {
                        transform: "translate(14, 0)"
                      }, starWhite));
    case 3 :
        return React.createElement("g", {
                    className: "pointer-events-none",
                    transform: "translate(22, 22)"
                  }, React.createElement("path", {
                        d: getStarBgPath(32),
                        fill: "rgba(96, 125, 139, 0.55)",
                        strokeWidth: "0px",
                        transform: "translate(6, 0)"
                      }), starGold, React.createElement("g", {
                        transform: "translate(14, 0)"
                      }, starGold), React.createElement("g", {
                        transform: "translate(28, 0)"
                      }, starGold));
    case 4 :
        return React.createElement("g", {
                    className: "pointer-events-none",
                    transform: "translate(15, 22)"
                  }, React.createElement("path", {
                        d: getStarBgPath(46),
                        fill: "rgba(96, 125, 139, 0.55)",
                        strokeWidth: "0px",
                        transform: "translate(6, 0)"
                      }), starTeal, React.createElement("g", {
                        transform: "translate(14, 0)"
                      }, starTeal), React.createElement("g", {
                        transform: "translate(28, 0)"
                      }, starTeal), React.createElement("g", {
                        transform: "translate(42, 0)"
                      }, starTeal));
    default:
      return null;
  }
}

var make = TbHexStarLevel;

export {
  getStarBgPath ,
  starGold ,
  starTeal ,
  starWhite ,
  make ,
  
}
/* starGold Not a pure module */
